import React, { Fragment, useEffect } from 'react'
import './index.css'
import {Link} from 'react-router-dom'
import  gsap from 'gsap'
import ScrollMagic from "../../../scrollMagic";
var tl = new gsap.timeline({paused: true});
const PortolioPost = (props) => {
 const start = () => {
   console.log('started');
 }

useEffect(() => {

    console.log(props);
  tl.pause(0);
     tl.kill();
     tl.clear();
     let trigger = '.postitem';
     tl
         .staggerFrom('.postitem', .3, { backgroundColor: 'transparent', opacity:0, ease: 'Power0.EaseIn'}, .15)
         .staggerFrom('.postanim', .5, {y: -180, autoAlpha: 0, opacity: 0, ease: 'Back.EaseIn'}, .25, "-=0.75");
     let controller = new ScrollMagic.Controller();
    let scene = new ScrollMagic.Scene({triggerElement: trigger, triggerHook: .6, reverse: false, offset: 0})
     .setTween(tl)
     .reverse(false)
         .addTo(controller);
      const postitems = document.querySelectorAll('.postitem');

        tl.resume();
}, []);



    return (
<Fragment>

             {
  props.dataDside.map((item, key) => {
    let x = Math.floor(Math.random() * 100000);
          return(
    <div key={key} className="grid" id={x}>
      <figure className="postitem">
                <div className="postanim">
                 <Link  to={`/${localStorage.getItem('lang')}/portfolio/${item.CURL}`}>
         <img className="itemimg" src={`${process.env.REACT_APP_DOMAIN}/${item.thumbnail}`}
             alt={item.name}/>
        <figcaption className="figcaption">
          <h2 className="itemhead">{item.name}</h2>
          {
            <span className="itemcat">{item.category.name}</span>
        }

        </figcaption>
            </Link>
            </div>

<noindex><a href={item.projectlink} className="montelink" rel="nofollow" target="_blank">{item.projectlink}</a></noindex>
      </figure>

    </div>
            )
  })
}

</Fragment>
    )


}

export default  PortolioPost



// WEBPACK FOOTER //
// ./src/components/DynamicContent/Header__Post/Portfolio__Post/index.js